import { gql } from 'urql';

const GetAutomaticChecking = gql`
  query GetAutomaticChecking {
    user {
      id
      customerInfo {
        __typename
        id
        myp {
          id
          percentage
          __typename
        }
        automaticSavings {
          __typename
          ... on AutomaticSavingsFeaturesEnabled {
            syc {
              enabled
            }
            syp {
              percentage
            }
          }
          ... on AutomaticSavingsFeaturesDisabled {
            title
            message
          }
        }
      }
    }
  }
`;

export default GetAutomaticChecking;
